import { createOptions } from './search';

export const useRoomAllocation = (flightsInput, numberOfRooms) => {
  const { people } = flightsInput;
  const { adult, childrenA, childrenB } = people;
  const totalPeopleNumber = adult + childrenA + childrenB;
  const totalChildrenNumber = childrenA + childrenB;

  const maxNumberOfRooms = adult;
  const numberOfRoomsOptions = createOptions(1, maxNumberOfRooms, '部屋').filter((o) => (
    totalPeopleNumber % o.value === 0 && totalChildrenNumber % o.value === 0
  ));
  const peoplePerRoom = totalPeopleNumber / numberOfRooms;

  return { numberOfRoomsOptions, peoplePerRoom };
};

const defaultNumberOfRooms = 1;

export const validateNumberOfRooms = (people, numberOfRooms) => {
  const { adult, childrenA, childrenB } = people;
  const totalPeopleNumber = adult + childrenA + childrenB;
  const totalChildrenNumber = childrenA + childrenB;

  const maxNumberOfRooms = adult;
  const isValidNumberOfRooms = (
    numberOfRooms <= maxNumberOfRooms &&
    totalPeopleNumber % numberOfRooms === 0 &&
    totalChildrenNumber % numberOfRooms === 0
  );

  const validatedNumberOfRooms = isValidNumberOfRooms ? numberOfRooms : defaultNumberOfRooms;
  const validatedPeoplePerRoom = totalPeopleNumber / validatedNumberOfRooms;

  return {
    validatedNumberOfRooms,
    validatedPeoplePerRoom,
  };
};
